import { isRecoverableAuth0OauthError } from '@/providers/auth/is-recoverable-auth0-oauth-error';

const PREVENT_INFINITE_LOOP_KEY = 'webapp-prevent-infiniteloop';

/**
 * Reloads the app once for a recoverable Auth0 OAuth error.
 * Returns true when a reload was triggered; false when the caller must surface the error.
 */
export function recoverFromAuth0OauthError(error: unknown): boolean {
  if (
    error instanceof Error &&
    isRecoverableAuth0OauthError(error.message) &&
    // The sessionStorage flag stops a second reload if the error persists.
    sessionStorage.getItem(PREVENT_INFINITE_LOOP_KEY) !== '1'
  ) {
    sessionStorage.setItem(PREVENT_INFINITE_LOOP_KEY, '1');
    window.location.replace('/');
    return true;
  }

  sessionStorage.removeItem(PREVENT_INFINITE_LOOP_KEY);
  return false;
}
